/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

const initialState = {
  headerData: {
    pageTitle: '',
    sideBar: false,
    listItems: [],
    activeMenuItem: '',
    activeParent: '',
    sidebarOpen: true,
    heading: '',
  },
}

function header(state = initialState, action) {
  const temp = Object.assign({}, state.headerData)
  if (action.type === 'HEADER') {
    Object.keys(action.payload).forEach((item) => {
      temp[item] = action.payload[item]
    })
    return {
      ...state,
      headerData: temp,
    }
  } else {
    return state
  }
}

export default header
